import { TableDataSource } from 'common/table/table-data-source';
import { ApiProductRevision, ApiV1Service } from 'api';
import { inject } from '@angular/core';
import { PagedResult, PageLoadParams } from 'common/table/paged-result.interface';
import { EMPTY, firstValueFrom, Observable } from 'rxjs';

export class RevisionsDataSource extends TableDataSource<ApiProductRevision> {
  private apiService = inject(ApiV1Service);

  private _productId?: number;

  set productId(value: number) {
    this._productId = value;
  }

  protected fetchPage(pageLoadParams: PageLoadParams): Observable<PagedResult<ApiProductRevision>> {
    if (this._productId === undefined) {
      return EMPTY;
    }

    return this.apiService.getProductRevisionsForProduct(
      this._productId,
      pageLoadParams.page,
      pageLoadParams.pageSize,
      pageLoadParams.sortBy,
      pageLoadParams.sortDirection,
    );
  }

  async deleteByIds(ids: number[]): Promise<void> {
    await firstValueFrom(this.apiService.deleteProductRevisions(ids));
  }
}
